import { useCallback } from 'react'
import ModalDeleteFilled from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import { RowData } from '../../../../../../../../../../baseComponents/TwinTable/types'
import { TPVOrderData } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/types'
import { twinFetchPostJSON } from '../../../../../../../../../../utils/globals/data'
import { SetEditDeleteModalTy } from '../../../../../../../../../../utils/hooks/useEditDeleteModal'
import useIsLoading from '../../../../../../../../../../utils/hooks/useIsLoading'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'

interface ModalCancelSellTicketPartialProps extends ModalCancelSellTicketPartialLogicProps {
}

const ModalCancelSellTicketPartial: React.FC<ModalCancelSellTicketPartialProps> = ({ setOpened, ...rest }) => {
    const { t } = useTwinTranslation()
    const { handleCancelSellTicketPartial, loading } = useModalCancelSellTicketPartialLogic({ setOpened, ...rest})
    return (
        <ModalDeleteFilled opened={true} setOpened={() => {}} onCancel={() => rest.setOpenModal(null)} onAccept={handleCancelSellTicketPartial} translations={{
            title: t('sureCancelthisTicket', '¿Seguro que quieres cancelar este ticket?'),
            subtitle: t('onceCanceledNotRecoverM', 'Una vez cancelado no podrás recuperarlo'),
            buttonAccept: t('cancel', 'Descartar'),
            buttonCancel: t('return', 'Volver')
        }} className='text-gray-51' loading={loading} />
    )
}

interface ModalCancelSellTicketPartialLogicProps extends ModalEditComponentProps {
    allRowData: RowData
    setOpenModal: SetEditDeleteModalTy
    completeData: TPVOrderData
}

const useModalCancelSellTicketPartialLogic = ({ allRowData, setOpenModal, completeData }: ModalCancelSellTicketPartialLogicProps) => {
    const { startLoading, endLoading, loading } = useIsLoading()
    const handleCancelSellTicketPartial = useCallback(async () => {
        startLoading?.()
        const result = await twinFetchPostJSON('/api/app/order/tpv/sellTicket/cancelSellTicketPartialCharge', { ...allRowData?.values, WarehouseId: allRowData?.WarehouseId, WorkingCenterId: allRowData?.WorkingCenterId })
        if (result) {
            let headerData = completeData?.header
            if (result?.full_assigned_number) {
                headerData = { ...headerData, full_assigned_number: result?.full_assigned_number }
            }
            setOpenModal({ type: 'delete', allRowData: { ...allRowData.values, CurrencyId: completeData?.header?.CurrencyId, headerData, OrderId: completeData?.header?.id, myTotalPayments: { total: completeData?.header?.total_payed}, WorkingCenterId: completeData?.cashRegister?.WorkingCenterId} })
        }
        endLoading?.()
    }, [allRowData, completeData, startLoading, endLoading, setOpenModal])

    return { handleCancelSellTicketPartial, loading }
}


export default ModalCancelSellTicketPartial